module.exports = __webpack_public_path__ + "img/download.0934b6cf.png";